import { iconUrl } from '../lib/icons';

/**
 * Renders a category's pixel-art icon at a fixed pixel-grid size. Stays
 * perfectly crisp (no browser smoothing) via CSS `image-rendering: pixelated`.
 * Falls back to nothing when a category has no icon assigned, so callers can
 * unconditionally drop one in without worrying about old rows.
 */
export function CategoryIcon({
  slug,
  size = 18,
  alt = '',
}: {
  slug: string | null | undefined;
  size?: number;
  alt?: string;
}) {
  const src = iconUrl(slug);
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        imageRendering: 'pixelated',
        flexShrink: 0,
        objectFit: 'contain',
        verticalAlign: 'middle',
      }}
    />
  );
}
